import * as webauthnJSON from "../index";
(globalThis as any).webauthnJSON = webauthnJSON;
